import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=74fe4e84&lang=pug&"
import script from "./subMenu.vue?vue&type=script&lang=js&"
export * from "./subMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports